import type { BreadcrumbsProps } from '@/components/Breadcrumbs/types';
import type { BreadcrumbList, WithContext } from 'schema-dts';

const LEADING_SLASH = /^\//;

const toAbsoluteUrl = (relativeUrl: string): string => {
  const rawBase = process.env.NEXT_PUBLIC_FE_BASE_URL || 'https://uppbeat.io/';
  const base = rawBase.endsWith('/') ? rawBase : `${rawBase}/`;

  return new URL(relativeUrl.replace(LEADING_SLASH, ''), base).href;
};

export const getBreadcrumbListSchema = (
  breadcrumbs: BreadcrumbsProps
): WithContext<BreadcrumbList> => {
  const items = [...(breadcrumbs.previous ?? []), breadcrumbs.current];

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label ?? item.slug,
      item: toAbsoluteUrl(item.relative_url),
    })),
  };
};
